import script from "./EstimateApproveModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EstimateApproveModal.vue?vue&type=script&setup=true&lang=ts"

import "./EstimateApproveModal.vue?vue&type=style&index=0&id=7a28bd5b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a28bd5b"]])

export default __exports__